module.exports = __webpack_public_path__ + "img/facebook.9e67987.svg";